import '../styles/Header.css';
import zeldle2 from '../assets/zeldle8.png'
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import flagFR from '../assets/flags/fr.svg'
import flagGB from '../assets/flags/gb.svg'
import flagJP from '../assets/flags/jp.svg'

function Header() {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);

  const languages = [
    { code: 'fr', flag: flagFR, label: 'Français' },
    { code: 'en', flag: flagGB, label: 'English' },
    { code: 'ja', flag: flagJP, label: '日本語' },
  ];

  const current = languages.find(l => l.code === i18n.language) || languages[0];

  const handleSelect = (code) => {
    i18n.changeLanguage(code);
    setOpen(false);
  };

  return (
    <div className="header">
      <div className="image-container">
        <div className='image-container-div'>
          <Link className='logo-item-link' to="/">
            <img src={zeldle2} alt="zeldle" className="zoom-image"/>
          </Link>
        </div>
      </div>

      {/* Menu déroulant langue */}
      <div className="language-switcher">
        <button className="lang-selected" onClick={() => setOpen(!open)}>
          <img src={current.flag} alt={current.label} title={current.label} className="lang-flag" />
          <span className="lang-caret">▾</span>
        </button>

        {open && (
          <ul className="lang-dropdown">
            {languages.map(l => (
              <li
                key={l.code}
                className={`lang-option ${l.code === i18n.language ? 'active' : ''}`}
                onClick={() => handleSelect(l.code)}
              >
                <img src={l.flag} alt={l.label} title={l.label} className="lang-flag" />
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}

export default Header;